import React, { useEffect } from "react";
import { useParams } from "react-router-dom";
import {
  useQueryGroupTheme,
  useQueryServiceByServiceId,
  useQueryTheme,
} from "../api/queries";
import { getCorporateType, getStorageToken } from "../utils";
import { AppBar, Body, LoadingPage } from "../components";
import { PaymentProvider } from "../context/paymentContext";
import { PaymentPage } from "../shared";
import { Box } from "@mui/material";
import { useTheme } from "../hooks";
import { ThemeProps } from "../models/theme";
import { CorporateService } from "../models/Service";

const Service = () => {
  const token = getStorageToken();
  const { corporateName = "", id = "" } = useParams();
  const {
    data,
    isLoading: isLoadingTheme,
    isFetching,
  } = useQueryTheme({
    corporateName,
    enabled: !!token && !!corporateName,
    authorisation: token || "",
  });

  const { updateTheme, theme } = useTheme();

  useEffect(() => {
    updateTheme(data as ThemeProps);
  }, [data]);

  const { data: corporate, isLoading: isLoadingCorporateThemeDetails } =
    useQueryGroupTheme({
      id: theme?.id,
      groupType: getCorporateType(theme?.url_type),
      enable: !!theme?.id,
      authorisation: token || "",
    });

  const corporateId = corporate?.id || "";

  const service = useQueryServiceByServiceId({
    corporateId,
    serviceId: id,
    enabled: !!token && !!id,
    authorisation: token || "",
  });

  if (
    isFetching ||
    isLoadingTheme ||
    isLoadingCorporateThemeDetails ||
    service?.isLoading
  )
    return <LoadingPage />;

  return (
    <PaymentProvider>
      <Body>
        <AppBar theme={theme} />
        <Box my={2}>
          <PaymentPage
            theme={theme}
            corporateId={corporateId}
            service={service?.data as CorporateService}
          />
        </Box>
      </Body>
    </PaymentProvider>
  );
};

export default Service;
